<template>
  <ag-confirm-dialog
    :title="$t('general.confirmation')"
    :message="openCloseButton.confirmMessage"
    :cancel-label="$t('general.cancel')"
    :confirm-label="openCloseButton.confirmButton"
    validation-btn-color="accent"
    @confirm="openCloseButton.handler"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :loading="loading"
        :color="openCloseButton.color"
        small
        block
        v-bind="attrs"
        v-on="on"
      >
        {{ openCloseButton.text }}
        <v-icon right v-text="openCloseButton.icon" />
      </v-btn>
    </template>
  </ag-confirm-dialog>
</template>

<script>
import Repositories from 'src/repositories'
import { mapActions } from 'vuex'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'

export default {
  name: 'OpenCloseSessionButton',
  components: {
    AgConfirmDialog,
  },
  props: {
    session: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    openButton () {
      return {
        icon: 'mdi-lock-open',
        color: 'accent',
        handler: this.open,
        text: this.$t('animation.menu.buttons.open'),
        confirmMessage: this.$t('animation.menu.session.opened.confirmMessage'),
        confirmButton: this.$t('animation.menu.session.opened.confirmButton'),
      }
    },
    closeButton () {
      return {
        icon: 'mdi-lock',
        color: 'accent',
        handler: this.close,
        text: this.$t('animation.menu.buttons.close'),
        confirmMessage: this.$t('animation.menu.session.closed.confirmMessage'),
        confirmButton: this.$t('animation.menu.session.closed.confirmButton'),
      }
    },
    reopenButton () {
      return {
        icon: 'mdi-lock-open',
        color: 'accent',
        handler: this.open,
        text: this.$t('animation.menu.buttons.reopen'),
        confirmMessage: this.$t('animation.menu.session.reopened.confirmMessage'),
        confirmButton: this.$t('animation.menu.session.reopened.confirmButton'),
      }
    },
    openCloseButton () {
      return {
        created: this.openButton,
        opened: this.closeButton,
        closed: this.reopenButton,
      }[this.session.status]
    },
  },
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    ...mapActions('animation', {
      patchSession: 'patchSession',
    }),
    async open () {
      this.loading = true
      try {
        const patch = { id: this.session.id, status: 'opened' }
        await Repositories.trainingSession.session.patch(patch)
        this.patchSession(patch)
        this.showSuccessNotification(this.$t('animation.menu.session.opened.success'))
      }
      catch (error) {
        this.showErrorNotification(this.$t('animation.menu.session.opened.error'))
      }
      finally {
        this.loading = false
      }
    },
    async close () {
      this.loading = true
      try {
        const patch = { id: this.session.id, status: 'closed' }
        await Repositories.trainingSession.session.patch(patch)
        this.patchSession(patch)
        this.showSuccessNotification(this.$t('animation.menu.session.closed.success'))
      }
      catch (error) {
        this.showErrorNotification(this.$t('animation.menu.session.closed.error'))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
